import Link from "next/link";
import useCRMTheme from "@/hooks/useCRMTheme";
import { useSelector } from "react-redux";
import { selectRoles } from "@/store/slices/roles/rolesSlice";
import { getHomePath } from "@/routes/home-path";

const Logo = ({
  sx = {},
  isPublic = false,
  customImage = null,
  redirection = true,
  onLoad = () => {},
}) => {
  const { navbarLogo } = useCRMTheme(isPublic);
  const roleState = useSelector(selectRoles);
  const homePath = isPublic ? "/crm" : getHomePath(roleState?.roles);

  const onDisable = (e) => {
    e.preventDefault(); // stop navigation
    console.log("Link clicked but navigation prevented!");
  };
  return (
    <Link
      href={homePath}
      className="link-logo"
      {...(redirection ? {} : { onClick: onDisable })}
    >
      {/* <LogoComponent login /> */}
      <div
        style={{
          // maxWidth: "170px",
          maxHeight: "30px",
          marginRight: "10px",
          marginTop: "-13px",
          ...sx,
        }}
      >
        <img
          src={customImage || navbarLogo}
          loading="lazy"
          style={{
            height: "auto",
            maxHeight: "inherit",
            maxWidth: "inherit",
          }}
          onLoad={onLoad}
        />
      </div>
    </Link>
  );
};

export default Logo;
